import {
  SET_ROLE_DATA,
  ROLE_FETCHING_INIT,
  ROLE_FETCHING_COMPLETED,
  SET_ROLES,
} from "./types";
const initialState = {
  _roles: [],
  _roles_list: [],
  _fetching: false,
  _refetch: false,
  _refetch_force: false,
  _selected_role: "",
  _selected_role_list: [],
  _disable_btn: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ROLE_DATA:
      return { ...state, ...action.payload };
    case ROLE_FETCHING_INIT: {
      return {
        ...state,
        _fetching: true,
        _refetch: false,
        _refetch_force: false,
      };
    }
    case ROLE_FETCHING_COMPLETED: {
      return { ...state, _fetching: false, ...action.payload };
    }
    case SET_ROLES: {
      return { ...state, _roles: action.payload };
    }
    default:
      return state;
  }
};
